/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui';



/* ++++++++++ --------------- TRENDING NOW ANALYTICS - TOTAL CLICKS REPORT : STYLES --------------- ++++++++++ */
export default {
    totalclicksreport: {
        marginBottom: pxToEm(16)
    }
};
